module.exports = __webpack_public_path__ + "static/casinoproffa-1296d39621cd7dd540c3d817971d81b8.jpg";